import React, { useState } from 'react'
import { compose } from 'recompose'
import { connect } from 'formik'
import { IntlShape, injectIntl } from 'react-intl'
import Tooltip from '../Tooltip'
import Input from '@iui-kit/components/Input'
import BEM from '@iui-kit/utils/bem'
import { Formik } from '@src/types/BriefSearch/formikProps'

const bem = new BEM(require('./InputTooltip.css'))

if (!Intl.PluralRules) {
  require('@formatjs/intl-pluralrules/polyfill')
  require('@formatjs/intl-pluralrules/dist/locale-data/ru')
}

interface Props {
  name: string
  value: string
  isValid: boolean
  inputMaxLength: number
}

interface HOCProps {
  formik: Formik
  intl: IntlShape
}

const InputTooltip: React.FC<Props & HOCProps> = props => {
  const {
    name,
    value,
    isValid,
    inputMaxLength,
    formik: { handleBlur, setFieldValue },
    intl: { formatMessage }
  } = props
  const [showTooltip, setShowTooltip] = useState<boolean>(false)
  const [charactersLeft, setCharactersLeft] = useState<number>(inputMaxLength)

  const handleCharactersLeft = (inputLength: number) => {
    const charactersLeft: number = inputMaxLength - inputLength
    const charactersLeftResult: number = charactersLeft < 1 ? 0 : charactersLeft

    setCharactersLeft(charactersLeftResult)
  }

  const handleShowTooltip = (e: React.FocusEvent<HTMLInputElement>) => {
    const inputLength: number = e.target.value.length

    handleCharactersLeft(inputLength)
    setShowTooltip(true)
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue: string = e.target.value
    const inputLength: number = inputValue.length

    handleCharactersLeft(inputLength)

    if (inputLength <= inputMaxLength) {
      setFieldValue(name, inputValue)
    }
  }

  const handleInputBlur = (e: React.FormEvent<HTMLInputElement>) => {
    setShowTooltip(false)
    handleBlur(e)
  }

  return (
    <div className={bem.b('InputTooltip').show()}>
      <Input
        size="l"
        name={name}
        value={value}
        onChange={handleInputChange}
        onBlur={handleInputBlur}
        onFocus={handleShowTooltip}
        valid={isValid}
      />
      {showTooltip && (
        <Tooltip
          className={bem
            .b('InputTooltip')
            .e('tooltip')
            .show()}
        >
          {formatMessage({ id: 'Brief.input.tooltip.left' }, { left: charactersLeft })}{' '}
          {charactersLeft}{' '}
          {formatMessage({ id: 'Brief.input.tooltip.symbols' }, { left: charactersLeft })}
        </Tooltip>
      )}
    </div>
  )
}

export default compose<React.FC>(connect, injectIntl)(InputTooltip)
